<template>
  <div
    v-if="data"
    class="mission-page"
    :class="{ 'has-bet-sheet': selectedCount() > 0 }"
  >
    <header class="mission-header">
      <button
        type="button"
        class="header-btn"
        @click="$router.push('/user')"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>{{ $t('buyMission.title') }}</h1>
      <button
        type="button"
        class="header-btn"
        @click="$router.push('/order')"
      >
        <van-icon
          name="orders-o"
          size="22"
        />
      </button>
    </header>

    <main class="mission-content">
      <section class="round-section">
        <div class="round-label">
          {{ $t('buyMission.currentSponsorshipRound') }}
        </div>
        <div class="round-title">
          <strong>{{ periodCode() }}</strong>
          <span>{{ $t('buyMission.round') }}</span>
        </div>
        <div class="round-time">
          <van-count-down
            :time="data && data.time ? data.time * 1000 : 0"
            @finish="finish"
          >
            <template #default="timeData">
              {{ formatCountdown(timeData) }}
            </template>
          </van-count-down>
        </div>
      </section>

      <div class="round-bar">
        <strong>
          <!-- {{ periodCode() }} -->
        </strong>
        <button
          type="button"
          class="history-toggle"
          @click="toggleHistory"
        >
          {{ $t('buyMission.sponsorshipResults') }}
          <van-icon :name="historyOpen ? 'arrow-up' : 'arrow-down'" />
        </button>
      </div>

      <section
        v-if="historyOpen"
        class="history-board"
      >
        <div
          v-for="(item, historyIndex) in historyList()"
          :key="historyIndex"
          class="history-row"
        >
          <span class="history-code">{{ item.code }}</span>
          <!-- <span class="history-digits">
            <b
              v-for="(digit, digitIndex) in item.digits"
              :key="digitIndex"
            >{{ digit }}</b>
          </span>
          <span class="history-total">{{ item.total }}</span> -->
          <span
            class="result-pill"
            :class="'is-' + item.firstKey"
          >{{ item.first }}</span>
          <span
            class="result-pill"
            :class="'is-' + item.secondKey"
          >{{ item.second }}</span>
        </div>
      </section>

      <section
        v-else
        class="reservation-panel"
      >
        <h2>{{ $t('buyMission.managerReservation') }}</h2>
        <div class="option-grid">
          <button
            type="button"
            class="mission-option"
            :class="{ checked: da == 1 }"
            @click="toggleOption('da')"
          >
            <img
              src="../images/ban5/huojian.gif"
              alt=""
            >
            <span>{{ $t('buyMission.rose') }}</span>
            <span
              v-if="da == 1"
              class="option-check"
            >
              <van-icon name="success" />
            </span>
          </button>
          <button
            type="button"
            class="mission-option"
            :class="{ checked: xiao == 1 }"
            @click="toggleOption('xiao')"
          >
            <img
              src="../images/ban5/love.gif"
              alt=""
            >
            <span>{{ $t('buyMission.lily') }}</span>
            <span
              v-if="xiao == 1"
              class="option-check"
            >
              <van-icon name="success" />
            </span>
          </button>
          <button
            type="button"
            class="mission-option"
            :class="{ checked: dan == 1 }"
            @click="toggleOption('dan')"
          >
            <img
              src="../images/ban5/youting.gif"
              alt=""
            >
            <span>{{ $t('buyMission.fireworks') }}</span>
            <span
              v-if="dan == 1"
              class="option-check"
            >
              <van-icon name="success" />
            </span>
          </button>
          <button
            type="button"
            class="mission-option"
            :class="{ checked: shuang == 1 }"
            @click="toggleOption('shuang')"
          >
            <img
              src="../images/ban5/meigui.gif"
              alt=""
            >
            <span>{{ $t('buyMission.balloon') }}</span>
            <span
              v-if="shuang == 1"
              class="option-check"
            >
              <van-icon name="success" />
            </span>
          </button>
        </div>
      </section>
    </main>

    <div
      v-if="selectedCount() > 0"
      class="bet-sheet"
    >
      <div class="bet-title">
        <span />
        {{ selectedCount() }} {{ ticketLabel }}
      </div>
      <div class="bet-form">
        <label>{{ $t('buyMission.perSlipPoints') }}:</label>
        <input
          v-model.trim="num"
          type="number"
          min="1"
          step="1000"
          class="bet-input"
        >
      </div>
      <button
        type="button"
        class="bet-submit"
        :class="{ disabled: submitting }"
        :disabled="submitting"
        @click="buy"
      >
        {{ $t('buyMission.confirmSubmit') }}
      </button>
    </div>

    <van-overlay
      :show="show1"
      @click="show1 = false"
    >
      <div
        class="wrapper1"
        @click.stop
      >
        <div class="block">
          <van-circle
            v-model="currentRate"
            :stroke-width="60"
            rate="0"
            size="100%"
            :color="gradientColor"
            :text="$t('pro2.loading')"
          />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
	import Fetch from "../../utils/fetch";
	import Vue from 'vue';
	import {
		Overlay,
		Circle,
		Dialog,
		CountDown,
		Icon,
		Toast
	} from 'vant';

	Vue.use(Overlay)
		.use(Circle)
		.use(Dialog)
		.use(CountDown)
		.use(Icon)
		.use(Toast);

	export default {
		name: "Buy",
		data() {
			return {
				show1: false,
				submitting: false,
				currentRate: 0,
				gradientColor: {
					'0%': '#ff8f00',
					'100%': '#0064d3'
				},
				data: null,
				index: 0,
				acc: null,
				show_tz: false,
				num: '',
				da: 0,
				xiao: 0,
				dan: 0,
				shuang: 0,
				kai: null,
				items: null,
				kais: null,
				imgs: null,
				historyOpen: false,
				time: 5000000
			};
		},
		computed: {
			ticketLabel() {
				return this.selectedCount() === 1 ? this.$t('buyMission.ticketSelected') : this.$t('buyMission.ticketsSelected');
			}
		},
		created() {
			this.$parent.footer('item', false);
		},
		mounted() {
			this.index = this.$router.history.current.params.code;
			this.start();
			this.accinfo();
		},
		methods: {
			periodCode() {
				return this.data && this.data.qi ? this.data.qi : "";
			},
			formatCountdown(timeData) {
				var minutes = timeData.minutes < 10 ? "0" + timeData.minutes : timeData.minutes;
				var seconds = timeData.seconds < 10 ? "0" + timeData.seconds : timeData.seconds;
				return minutes + ":" + seconds;
			},
			toggleHistory() {
				this.historyOpen = !this.historyOpen;
			},
			toggleOption(key) {
				this[key] = this[key] == 1 ? 0 : 1;
			},
			selectedCount() {
				return Number(this.da) + Number(this.xiao) + Number(this.dan) + Number(this.shuang);
			},
			selectedMoney() {
				var money = parseFloat(this.num);
				if (isNaN(money) || money < 0) {
					money = 0;
				}
				return this.selectedCount() * money;
			},
			historyList() {
				var list = [];
				var source = this.kais && this.kais.length ? this.kais : [];
				for (var i = 0; i < source.length; i++) {
					list.push(this.createHistoryRow(source[i], i));
				}
				if (!list.length) {
					var baseCode = parseInt(this.periodCode(), 10) || 202606093441;
					for (var j = 1; j <= 16; j++) {
						list.push(this.createHistoryRow({
							ino: baseCode - j,
							da: j % 3 === 0 ? 1 : 0,
							dan: j % 4 === 0 ? 0 : 1
						}, j));
					}
				}
				return list;
			},
			createHistoryRow(item, index) {
				var code = item.ino || item.qi || item.id || (parseInt(this.periodCode(), 10) - index - 1);
				var firstKey = parseInt(item.da, 10) === 1 ? 'lily' : 'rose';
				var secondKey = parseInt(item.dan, 10) === 1 ? 'balloon' : 'fireworks';
				var digits = this.createVisualDigits(code, index);
				var total = digits.reduce(function(sum, digit) {
					return sum + digit;
				}, 0);
				return {
					code: code,
					digits: digits,
					total: total,
					firstKey: firstKey,
					secondKey: secondKey,
					first: this.$t('buyMission.' + firstKey),
					second: this.$t('buyMission.' + secondKey)
				};
			},
			createVisualDigits(code, index) {
				var raw = String(code || "").replace(/\D/g, "");
				var seed = raw.slice(-3);
				if (seed.length < 3) {
					seed = (seed + String(index + 137)).slice(0, 3);
				}
				var digits = [];
				for (var i = 0; i < 3; i++) {
					var digit = parseInt(seed.charAt(i), 10);
					if (isNaN(digit)) {
						digit = index + i + 1;
					}
					digits.push((digit % 6) + 1);
				}
				return digits;
			},
			graptime(randomInt) {
				this.currentRate += randomInt;
				if (this.currentRate < 100) {
					setTimeout(() => {
						this.graptime(randomInt);
					}, 1000);
				} else {
					this.show1 = false;
					this.start();
					this.accinfo();
				}
			},
			finish() {
				this.show1 = true;
				var randomInt = Math.floor(Math.random() * 20) + 10;
				this.currentRate = 0;
				this.graptime(randomInt);
			},
			accinfo() {
				Fetch('/user/info').then((r) => {
					this.acc = r.data;
				});
			},
			maxnum() {
				// this.number = this.data.max;
			},
			start() {
				Fetch('/index/item_detail', {
					id: this.index
				}).then(res => {
					this.data = res.data;
					this.vip = res.data.vip;
					this.kais = res.data.kais;
					if (this.kais) {
						this.kai = this.kais[0];
					}
				});
				Fetch('/index/itemslist').then(res => {
					this.items = res.data;
				});
			},
			buy() {
				if (this.submitting) {
					return false;
				}
				var amount = this.da + this.xiao + this.dan + this.shuang;
				var money = parseFloat(this.num);
				if (amount == 0) {
					this.$toast(this.$t('pro.seltype'));
					return false;
				}
				if (isNaN(money) || money < 1) {
					this.$toast(this.$t('pro.minmoney0'));
					return false;
				}
				amount = amount * money;
				if (this.acc && amount > Number(this.acc.money || 0)) {
					this.$toast(this.$t('pro.insufficient'));
					return false;
				}
				Dialog.confirm({
					title: '',
					confirmButtonText: this.$t('utils.confirm'),
					cancelButtonText: this.$t('utils.cancel'),
					message: this.$t('pro.issubmit')
				}).then(() => {
					this.submitting = true;
					Fetch("/user/item_buy", {
						id: this.data.id,
						money: this.num,
						da: this.da,
						xiao: this.xiao,
						dan: this.dan,
						shuang: this.shuang
					}).then(r => {
						if (r.data && r.data > 0) {
							this.$router.push("/invest");
						} else {
							this.$router.push("/order");
						}
					}).catch(err => {
						console.log(err);
					}).then(() => {
						this.submitting = false;
					});
				}).catch(() => {});
				return true;
			}
		}
	};
</script>

<style lang="less" scoped>
	.mission-page {
		min-height: 100vh;
		overflow-x: hidden;
		background: #1f1b1f;
		color: #fff;
		box-sizing: border-box;
		padding-bottom: 42px;
	}

	.mission-page.has-bet-sheet {
		padding-bottom: 230px;
	}

	.mission-header {
		height: 50px;
		display: grid;
		grid-template-columns: 64px 1fr 64px;
		align-items: center;
		background: #2c2c2c;
		border-bottom: 1px solid #564536;
		box-sizing: border-box;
	}

	.mission-header h1 {
		margin: 0;
		color: #f4bf89;
		font-size: 16px;
		font-weight: 500;
		line-height: 22px;
		text-align: center;
	}

	.header-btn {
		width: 100%;
		height: 100%;
		border: 0;
		background: transparent;
		color: #ffc292;
		font-size: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.mission-content {
		padding: 30px 0 0;
		box-sizing: border-box;
	}

	.round-section {
		color: #fff;
		margin-left: 23px;
	}

	.round-label {
		font-size: 14px;
		font-weight: 700;
		line-height: 22px;
	}

	.round-title {
		margin-top: 10px;
		display: flex;
		align-items: baseline;
		gap: 8px;
		font-size: 14px;
		line-height: 22px;
	}

	.round-title strong {
		font-size: 16px;
		font-weight: 800;
		letter-spacing: 0;
	}

	.round-time {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		min-width: 72px;
		height: 33px;
		margin-top: 14px;
		padding: 0 8px;
		border: 1px solid rgba(255, 255, 255, .82);
		border-radius: 4px;
		box-sizing: border-box;
		color: #fff;
		font-size: 16px;
		font-weight: 700;
	}

	.round-time /deep/ .van-count-down {
		color: #fff;
		font-size: 16px;
		font-weight: 700;
		line-height: 31px;
	}

	.round-bar {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 30px 15px;
		color: #fff;
		font-size: 14px;
		line-height: 20px;
		margin-bottom: 15px;
	}

	.round-bar strong {
		font-weight: 700;
	}

	.history-toggle {
		border: 0;
		background: transparent;
		color: #fff;
		display: inline-flex;
		align-items: center;
		gap: 4px;
		padding: 0;
		font-size: 14px;
		font-weight: 600;
		line-height: 20px;
	}

	.reservation-panel {
		margin-top: 22px;
		padding: 16px 16px 30px;
		border: 1px solid #715e4b;
		border-radius: 10px;
		background: #292929;
		box-sizing: border-box;
		margin: 0 10px;
	}

	.reservation-panel h2 {
		position: relative;
		margin: 0 0 25px;
		padding-left: 13px;
		color: #ffc292;
		font-size: 16px;
		font-weight: 800;
		line-height: 22px;
	}

	.reservation-panel h2:before {
		content: "";
		position: absolute;
		left: 0;
		top: 2px;
		width: 5px;
		height: 23px;
		background: #ff5e76;
	}

	.option-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 26px 16px;
	}

	.mission-option {
		position: relative;
		height: 136px;
		padding: 0 5px;
		border: 2px solid #76614f;
		border-radius: 10px;
		background: #1f1b1f;
		color: #fff;
		display: grid;
		grid-template-columns: 82px minmax(0, 1fr);
		align-items: center;
		column-gap: 10px;
		text-align: left;
		box-sizing: border-box;
		overflow: hidden;
	}

	.mission-option img {
		width: 86px;
		height: 86px;
		object-fit: contain;
		justify-self: center;
	}

	.mission-option span:not(.option-check) {
		min-width: 0;
		font-size: 14px;
		font-weight: 500;
		line-height: 22px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.mission-option.checked {
		border-color: #d3a673;
	}

	.option-check {
		position: absolute;
		right: 0;
		bottom: 0;
		width: 0;
		height: 0;
		border-left: 36px solid transparent;
		border-bottom: 36px solid #e5b67e;
	}

	.option-check .van-icon {
		position: absolute;
		right: 3px;
		bottom: -34px;
		color: #3a332c;
		font-size: 16px;
		font-weight: 800;
	}

	.history-board {
		margin-top: 10px;
		padding: 0 8px;
		border: 1px solid #ffd3d9;
		background: #fff;
		color: #000;
		box-sizing: border-box;
	}

	.history-row {
		min-height: 35px;
		display: grid;
		grid-template-columns: minmax(150px, 1.1fr) 72px 72px;
		padding: 5px;
		align-items: center;
		column-gap: 8px;
		border-bottom: 1px solid #d8d8d8;
		box-sizing: border-box;
	}

	.history-row:last-child {
		border-bottom: 0;
	}

	.history-code {
		min-width: 0;
		font-size: 14px;
		line-height: 20px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.history-digits {
		display: flex;
		gap: 9px;
		color: #e4b98f;
		font-size: 16px;
		font-weight: 800;
		line-height: 22px;
	}

	.history-total {
		width: 33px;
		height: 33px;
		border: 1px solid #efbd8c;
		border-radius: 50%;
		color: #d99d67;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		font-weight: 700;
		box-sizing: border-box;
	}

	.result-pill {
		min-width: 0;
		height: 25px;
		padding: 0 10px;
		border-radius: 11px;
		color: #fff;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		font-weight: 800;
		line-height: 16px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.result-pill.is-rose {
		background: #8b42f4;
	}

	.result-pill.is-lily {
		background: #f75b99;
	}

	.result-pill.is-fireworks {
		background: #ff766f;
	}

	.result-pill.is-balloon {
		background: #2997e8;
	}

	.bet-sheet {
		position: fixed;
		left: 50%;
		bottom: 0;
		z-index: 30;
		width: 100%;
		max-width: 600px;
		padding: 24px 24px 25px;
		border-top: 1px solid #5e4d3c;
		background: #2b2b2b;
		box-sizing: border-box;
		transform: translateX(-50%);
	}

	.bet-title {
		display: flex;
		align-items: center;
		color: #ffc292;
		font-size: 16px;
		font-weight: 800;
		line-height: 22px;
	}

	.bet-title span {
		width: 5px;
		height: 23px;
		margin-right: 7px;
		background: #ff5e76;
	}

	.bet-form {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 18px;
		margin-top: 26px;
	}

	.bet-form label {
		color: #ffc292;
		font-size: 14px;
		font-weight: 500;
		line-height: 20px;
		white-space: nowrap;
	}

	.bet-input {
		width: 150px;
		height: 46px;
		padding: 0 18px;
		border: 1px solid #6d5946;
		border-radius: 26px;
		background: #221e21;
		box-sizing: border-box;
		color: #fff;
		font-size: 14px;
		outline: none;
		text-align: center;
	}

	.bet-submit {
		display: block;
		width: calc(100% - 52px);
		height: 54px;
		margin: 18px auto 0;
		border: 0;
		border-radius: 6px;
		background: #edbd82;
		color: #73352e;
		font-size: 16px;
		font-weight: 800;
		line-height: 22px;
	}

	.bet-submit.disabled {
		opacity: .65;
	}

	.wrapper1 {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100vw;
		height: 100vh;
	}

	.block {
		width: 120px;
		height: 120px;
	}

	/deep/ .van-overlay {
		background-color: rgba(0, 0, 0, .72);
	}

	/deep/ .van-circle__text {
		color: #fff;
		font-size: 14px;
		font-weight: 700;
	}

	@media (max-width: 420px) {
		.mission-content {
			padding:  30px 0 0;
		}

		.round-label {
			font-size: 16px;
		}

		.round-title strong {
			font-size: 16px;
		}

		.round-bar,
		.history-toggle {
			font-size: 12px;
		}

		.reservation-panel {
			padding: 15px 15px 24px;
		}

		.option-grid {
			gap: 24px 16px;
		}

		.mission-option {
			height: 134px;
			grid-template-columns: 84px minmax(0, 1fr);
			padding:0 5px;
		}

		.mission-option img {
			width: 78px;
			height: 78px;
		}

		.history-row {
			grid-template-columns: minmax(150px, 1.1fr) 72px 72px;
			padding: 5px;
			column-gap: 6px;
		}

		.history-code {
			font-size: 14px;
		}

		.history-digits {
			gap: 6px;
			font-size: 16px;
		}

		.result-pill {
			height: 32px;
			padding: 0 8px;
			font-size: 14px;
		}

		.bet-input {
			width: 150px;
		}
	}

	@media (max-width: 360px) {
		.mission-content {
			padding-left: 18px;
			padding-right: 18px;
		}

		.option-grid {
			gap: 18px 14px;
		}

		.mission-option {
			height: 118px;
			grid-template-columns: 70px minmax(0, 1fr);
			padding-right: 18px;
		}

		.mission-option img {
			width: 66px;
			height: 66px;
		}

		.mission-option span:not(.option-check) {
			font-size: 16px;
		}

		.history-row {
			grid-template-columns: minmax(98px, 1fr) 58px 30px 50px minmax(58px, .8fr);
			column-gap: 4px;
		}

		.history-code {
			font-size: 14px;
		}

		.history-digits {
			gap: 4px;
			font-size: 16px;
		}

		.history-total {
			width: 28px;
			height: 28px;
			font-size: 12px;
		}

		.result-pill {
			height: 28px;
			border-radius: 9px;
			font-size: 12px;
		}

		.bet-form {
			gap: 10px;
		}

		.bet-form label {
			font-size: 14px;
		}

		.bet-input {
			width: 150px;
		}
	}
</style>
